import React from "react";


const NoPage = () => {
    return (

<>
      <div className='topHd'>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <h2>Sorry, Page not found</h2>
            </div>
          </div>
        </div>
      </div>
    </>

    )
  };
  
  export default NoPage;